import { render, staticRenderFns } from "./addEditCustomConfigTem.vue?vue&type=template&id=67ad0e69&scoped=true"
import script from "./addEditCustomConfigTem.vue?vue&type=script&lang=js"
export * from "./addEditCustomConfigTem.vue?vue&type=script&lang=js"
import style0 from "./addEditCustomConfigTem.vue?vue&type=style&index=0&id=67ad0e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad0e69",
  null
  
)

export default component.exports